var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-start-1 col-end-13"},[(_vm.thread.type != 'lineItem')?_c('div',{staticClass:"p-3",class:[
      _vm.thread.type === 'customer'
        ? 'col-start-1 col-end-8'
        : 'col-start-6 col-end-13'
    ]},[_c('div',{staticClass:"flex items-center",class:[
        _vm.thread.type === 'message' || _vm.thread.type === 'automation'
          ? 'justify-start flex-row-reverse'
          : ''
      ]},[_c('div',{staticClass:"flex items-center justify-center h-8 w-8 rounded-full text-white",class:[
          _vm.thread.type === 'customer'
            ? 'bg-indigo-500'
            : _vm.thread.type === 'automation'
            ? 'bg-blue-500'
            : 'bg-green-500'
        ]},[_vm._v(" "+_vm._s(_vm.getFirstCharacter(_vm.thread))+" ")]),_c('div',{staticClass:"relative text-sm py-2 px-4 shadow text-gray-800",class:[
          _vm.thread.type === 'customer'
            ? 'bg-white rounded-br-lg rounded-tl-lg ml-3'
            : _vm.thread.type === 'automation'
            ? 'bg-blue-100 rounded-bl-lg rounded-tr-lg mr-3'
            : 'bg-green-100 rounded-bl-lg rounded-tr-lg mr-3'
        ]},[(_vm.thread.context)?_c('ContextItem',{attrs:{"context":_vm.thread.context}}):_vm._e(),_c('p',{directives:[{name:"linkified",rawName:"v-linkified"}],staticClass:"whitespace-pre-wrap",domProps:{"innerHTML":_vm._s(_vm.thread.body)}}),_c('div',{staticClass:"text-right text-gray-400 text-xs mt-1"},[_vm._v(" "+_vm._s(_vm._f("messageTime")(_vm.thread.createdAt))+" ")]),(_vm.thread.attachments)?_c('div',_vm._l((_vm.thread.attachments),function(attachment,index){return _c('AttachmentItem',{key:index,attrs:{"attachment":attachment}})}),1):_vm._e()],1)])]):_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"text-xs text-cool-gray-700 pb-4",domProps:{"innerHTML":_vm._s(_vm.getLineItemText(_vm.thread))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }